<template>
  <div class="gpt-chat-content-area mv-h-full overflow-hidden" style="text-align: center">
    <div style="display: flex; margin-top: 5px;">
      <button @click="resetData" style="margin-left: 10px;">
          <v-icon>mdi-arrow-left</v-icon>
        </button>
      <div
      style="display: flex; justify-content: center; width: 100%; font-weight: bold;">
      <v-icon color="rgb(22,110,210)" size="20" style="margin-right: 3px;">mdi-image-auto-adjust</v-icon>
      {{ $i18n.t("optimize_home.home_title") }}
    </div>
    </div>
    <!-- optimize lab -->
    <div class="card">
      <div class="d-flex align-center mt-2 mb-2">
        <v-img :src="require('../../img/icons-write.png')" max-height="24px" max-width="24px" alt="logo" contain></v-img>
        <div class="editInput" style="color:darkred; white-space: nowrap; overflow: hidden;text-overflow: ellipsis;">
          {{ $i18n.t("home.text_general_placeholder") }}
        </div>
      </div>
      <div>
        <v-textarea ref="refInputTextArea" :value="optimize.generateContent"
          :placeholder="$t(optimize.placeholder)" v-model="optimize.generateContent" solo :rows="$t(rows)"
          background-color="rgb(251,255,242)"
          :style="{ size:'14px'}"></v-textarea>
      </div>
      <div v-show="!isloading" style="margin-top: -15px;">
        <div class="d-flex align-center">
           <!-- replace -->
           <button class="generatebtn" style="background-color: rgb(68,126,35);" @click="replace">
            <v-icon color="rgb(255,255,255)" size="15">mdi-file-replace-outline</v-icon>
            <div style="margin-left: 5px">{{ $i18n.t("optimize_home.btn_text_replace") }}</div>
          </button>
          <!-- keep -->
          <button class="generatebtn" @click="insert" style="margin-left: 6px;">
            <v-icon color="rgb(255,255,255)" size="15">mdi-hand-okay</v-icon>
            <div style="margin-left: 5px">{{ $i18n.t("optimize_home.btn_text_insert") }}</div>
          </button>
          <!-- regenerate -->
          <!-- <button class="generatebtn" style="margin-left: 6px; background-color: rgb(128,128,128);" @click="reGenerate(optimize.inputText)">
            <v-icon color="rgb(255,255,255)" size="15">mdi-refresh</v-icon>
            <div style="margin-left: 5px">{{ $i18n.t("optimize_home.btn_text_regenerate") }}</div>
          </button> -->
          <!-- adjust -->
          <button class="generatebtn" @click="menuControl" style="margin-left: 6px; background-color: rgb(123,180,96);">
            <div style="margin-left: 5px;">{{ $i18n.t("optimize_home.btn_text_adjust") }}</div>
            <v-icon ref="adjustThanks" size="18">mdi-chevron-up</v-icon>
          </button>
          <!-- adjust menu -->
          <ActionMenu ref="refTaskTypeMenu" @onClickMenu="onClickMenu" @clearInput="clearInput" />
        </div>
        <div class="generatewarning">{{optimize.warringText}}</div>
      </div>
      <div v-show="isloading" style="margin-top: -15px;">
        <GenerateProcessing />
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/

// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)
// // Pubsub
import { gptPubIds } from "@/service/wd_pubsub_config.js";
import { subscribe, unsubscribe } from "@/service/wd_pubsub.js";
import { process_addin } from "@/views/gpt/task/process_addin.js";
import { getCurrentSelectState, optimizeSelectContent, addContentforSelectShape,  insertTextShape } from "@/views/gpt/util/gpt_addin_utils";
import {convertLineBreakSymbolReverse, markdownSymbol} from "@/utils/wd_utils.js";

//例如: import <组件名称> from  <组建路径>
import GenerateProcessing from "../../widgets/processing/card-generate-processing.vue";
import ActionMenu from "../../widgets/action/optimize-action-menu.vue";
import { i18n } from "@/plugins/i18n.js";

export default {
  //import 引入的组件需要注入到对象中才能使用
  components: {
    GenerateProcessing,
    ActionMenu
  },
  props: {
    propsBot: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      rows: 13,
      maxHeight: window.innerHeight - 100,
      isloading: false,
      showMenu: false,
      optimize: {
        title: i18n.t("home.text_general_placeholder"),
        placeholder: i18n.t("home.text_general_placeholder"),
        inputText: "",
        type: "",
        content: "",
        isFinishGenerate: false,
        generateContent: "",
        warringText: i18n.t("home.text_general_warring_text"),
        isOptimizeGenerate: false
      }
    };
  },
  //计算机属性 类似与data概念
  computed: {},
  //监控data中数据变化
  watch: {},
  methods: {
    // inputPrompt的值是从上一个界面传过来的用户输入的内容，这里的方法是重新生成，因此这个值需要被保存/保留
    // reGenerate(inputPormpt) {
    //   this.optimize.isFinishGenerate = false
    //   this.isloading = true
    //   var selectedTaskType = {
    //     id: "task_word_create",
    //     title: "写一个文案"
    //   }
    //   if (inputPormpt == "" || inputPormpt == null) {
    //     this.$message.warning(i18n.t("word_add_in_main.text_content_empty"))
    //     return;
    //   }

    //   process_addin({
    //     text: inputPormpt,
    //     taskType: selectedTaskType,
    //     taskOptions: selectedTaskType,
    //     currentEmailBody: this.optimize.generateContent,
    //     isRegenerate: true
    //   });
    // },
    insert() {
      getCurrentSelectState((currentState) => {
        let slideState = currentState.selectSlide.state
        let shapeState = currentState.selectShape.state
        if (slideState == i18n.t("ppt_select_state.select_one_slide")) {
          switch (shapeState) {
            case i18n.t("ppt_select_state.select_no_shape"):
            case i18n.t("ppt_select_state.select_mluti_shapes"):
              // to 根据当前内容插入一个新的文本框
              insertTextShape(convertLineBreakSymbolReverse(this.optimize.generateContent))
              break;
            case i18n.t("ppt_select_state.select_one_shape"):
              // to 在当前shape内容后插入内容
              addContentforSelectShape(convertLineBreakSymbolReverse(this.optimize.generateContent))
              break;
            default:
              break;
          }
        } else {
          // todo 选中多个slides的时候，直接根据当前内容插入一页新的slide
        }
      })
    },
    replace() {
      getCurrentSelectState((currentState) => {
        let slideState = currentState.selectSlide.state
        let shapeState = currentState.selectShape.state
        if (slideState == i18n.t("ppt_select_state.select_one_slide")) {
          switch (shapeState) {
            case i18n.t("ppt_select_state.select_no_shape"):
            case i18n.t("ppt_select_state.select_mluti_shapes"):
              this.$message.warning(i18n.t("optimize_home.text_warning_select_no_shape"))
              break;
            case i18n.t("ppt_select_state.select_one_shape"):
              optimizeSelectContent(this.optimize.generateContent)
              break;
            default:
              break;
          }
        } else {
          this.$message.warning(i18n.t("optimize_home.text_warning_select_no_shape"))
        }
      })
    },
    menuControl() {
      if (!this.showMenu) {
        this.showMenu = true
      }
      if (this.showMenu) {
        this.$refs.refTaskTypeMenu.funcShowMenu(this.$refs.adjustThanks);
      } else {
        this.$refs.refTaskTypeMenu.funcHideMenu();
      }
    },
    onClickMenu(menu) {
      this.isloading = true

      this.optimize.isFinishGenerate = false

      var selectedTaskType = {
        id: menu.id,
        title: menu.value
      }
      process_addin({
        text: "按照要求优化文本的内容或格式",
        taskType: selectedTaskType,
        taskOptions: selectedTaskType,
        currentEmailBody: this.optimize.generateContent,
      });
    },
    clearInput() {
      this.showMenu = true
      if (this.showMenu) {
        this.$refs.refTaskTypeMenu.funcShowMenu(this.$refs.adjustThanks);
      } else {
        this.$refs.refTaskTypeMenu.funcHideMenu();
      }
    },
    pubCallback(msgName, data) {
      if (msgName == gptPubIds.pubId_Local_Addin_SystemLog) {
        this.optimize.generateContent = markdownSymbol(data.replace(/<br \/>/g, "\n"))
        this.optimize.isFinishGenerate = true
        this.optimize.warringText = i18n.t("optimize_home.text_finish_remind_text_optimize")
        this.isloading = false
      } else if (msgName == gptPubIds.pubId_Local_Gpt_Processing_Fail) {
        this.optimize.isFinishGenerate = false;
        this.isloading = false
        this.optimize.warringText = i18n.t("ppt_add_in_main.server_general_error_message")
        this.$message.error(data)
      } else if(msgName == gptPubIds.pubId_Local_PPT_init_error) {
        this.$message.warning(i18n.t("home.text_general_warring_ppt_init_error"))
      }
    },
    resetData() {
      this.optimize.placeholder = i18n.t("home.text_general_placeholder")
      this.optimize.inputText = ""
      this.optimize.isFinishGenerate = false
      this.optimize.generateContent = ""
      this.optimize.warringText = i18n.t("home.text_general_warring_text")

      this.$router.push("/chat-doc");
    },
    adjustHeight() {
      const maxHeight = window.innerHeight // 当前可视区高度  
      this.rows = Math.ceil((maxHeight - 180)/30) // 求出当前输入框最优行数
    }
  },
  //生命周期-创建完成(可以访问当前this实例)
  created() {},
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() {
    subscribe(gptPubIds.pubId_Local_Addin_SystemLog, this.pubCallback);
    subscribe(gptPubIds.pubId_Local_Gpt_Processing_Fail, this.pubCallback);
    subscribe(gptPubIds.pubId_Local_PPT_init_error, this.pubCallback);
    
    window.addEventListener('resize', this.adjustHeight); 
    this.adjustHeight();  
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.adjustHeight)
  },
  destroyed() {
    unsubscribe(this.pubCallback);
  }, //生命周期-销毁完成
  activated() { 
    this.optimize.title = this.$route.query.title
    this.optimize.placeholder = this.$route.query.placeholder
    this.optimize.generateContent = markdownSymbol(this.$route.query.generateContent)
    this.optimize.inputText = this.$route.query.inputText
    this.optimize.isOptimizeGenerate = this.$route.query.isOptimizeGenerate
  }, //如果页面有keep-alive,这函数会触发
};
</script>
<style lang="scss">
@import "~@/styles/apps/gpt.scss";
</style>
<style lang="scss">
.card {
  width: 96%;
  margin-top: 10px;
  display: inline-block;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  // border: 2px solid rgba(0, 0, 0, 0.1);  
  border-radius: 10px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19);
  padding: 0px 6px 5px 6px;
}

.editInput {
  background-color: rgb(255, 255, 255);
  /* border:1px solid #cecece; */
  color: #ffffff;
  font-size: 14px;
  padding: 0 5px 0 5px;
  margin-left: 10px;
  // display: flex;
  // align-items: center;
  // /* 垂直居中 */
  // justify-content: center;
  // /* 水平居中 */
  border-radius: 3px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
  ;
}

.generatebtn {
  height: 34px;
  width: 80px;
  line-height: 30px;
  background-color: rgb(22, 110, 210);
  /* border:1px solid #cecece; */
  color: #ffffff;
  font-size: 16px;
  padding: 0 2px;
  display: flex;
  align-items: center;
  /* 垂直居中 */
  justify-content: center;
  /* 水平居中 */
  border-radius: 6px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19);
  ;
}

.adjustbtn {
  height: 34px;
  width: 40px;
  margin-left: 10px;
  /* border:1px solid #cecece; */
  color: #ffffff;
  padding: 0 18px;
  display: flex;
  align-items: center;
  /* 垂直居中 */
  justify-content: center;
  /* 水平居中 */
  // border-radius: 6px;
  // box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19);
}

.regeneratebtn {
  height: 34px;
  width: 40px;
  margin-top: -10px;
  /* border:1px solid #cecece; */
  color: #ffffff;
  padding: 0 18px;
  display: flex;
  align-items: center;
  /* 垂直居中 */
  justify-content: center;
  /* 水平居中 */
  // border-radius: 6px;
  // box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19);
}

.generatewarning {
  /* border:1px solid #cecece; */
  color: black;
  font-size: 14px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  margin-left: auto;
}
</style>
